<template>
  <span class="loading loading-spinner loading-lg text-primary"></span>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>